import { render } from "./DebugPanel.vue?vue&type=template&id=4efe43ac&scoped=true"
import script from "./DebugPanel.vue?vue&type=script&lang=js"
export * from "./DebugPanel.vue?vue&type=script&lang=js"

import "./DebugPanel.vue?vue&type=style&index=0&id=4efe43ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4efe43ac"

export default script